export function escapeXML(unsafe) {
  if (typeof unsafe === "string") {
    return unsafe.replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
  } else {
    return unsafe;
  }
}

export function validateYtunnus(businessId) {
  let id = businessId.substring(0, 7);
  let check = businessId.substring(8, 9);
  if (typeof (check) === 'string') {
    check = parseInt(check);
    if (isNaN(check)) {
      console.log('Error: last number is NaN?');
      return false
    }
  }
  let multiplicationArray = [7, 9, 10, 5, 8, 4, 2];
  let a = id.split('');
  let sum = 0;

  for (let i = 0; i < a.length; i++) {
    sum = sum + a[i] * multiplicationArray[i];
  }

  let remainder = (sum % 11);
  if (remainder === 1) {
    return false
  }
  if (remainder === 0) {
    return check === remainder
  }
  return check === (11 - remainder)
}

export function validateEmail(email) {
  if (email === "") {
    return null;
  }
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}